// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationVerifyYourIdentityPath = 'M58.999 0c-20.159 0-36.5 16.342-36.5 36.5 0 10.163 4.154 19.357 10.856 25.975l-3.98 5.053-5.977-4.7L7.672 81.84C4.028 86.45 4.8 93.05 9.347 96.645l1.562 1.243c4.558 3.602 11.159 2.83 14.755-1.717l15.818-19.125-6.604-5.192 3.906-4.958A36.33 36.33 0 0058.999 73c20.158 0 36.5-16.342 36.5-36.5S79.157 0 58.999 0zm0 7c16.292 0 29.5 13.208 29.5 29.5S75.29 66 58.999 66c-16.293 0-29.5-13.208-29.5-29.5S42.706 7 58.999 7zm-13.18 20.18c0-7.28 5.9-13.18 13.18-13.18 7.279 0 13.18 5.9 13.18 13.18 0 3.383-1.275 6.468-3.37 8.802 5.783 3.341 9.705 9.546 9.827 16.676l.003.342h-7c0-6.98-5.66-12.64-12.64-12.64-6.879 0-12.474 5.494-12.637 12.333L46.36 53h-7c0-7.274 3.953-13.624 9.83-17.018a13.13 13.13 0 01-3.37-8.802zm19.36 0a6.18 6.18 0 11-12.36 0 6.18 6.18 0 0112.36 0zm-40.74 45.371l7.076 5.563L20.22 91.769c-1.246 1.575-3.446 1.833-4.963.635l-1.56-1.242a3.502 3.502 0 01-.583-4.922L24.439 72.55z';
var IllustrationVerifyYourIdentity = baseIllustration('IllustrationVerifyYourIdentity', {
  getPath: () => IllustrationVerifyYourIdentityPath
}, 'ColoredIllustrationVerifyYourIdentity');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationVerifyYourIdentity;
//# sourceMappingURL=index.js.map